import React, { memo, useState, useEffect } from 'react';
import Map, { Marker } from 'react-map-gl';
import { Resizable } from 're-resizable';
import { MAPBOX_TOKEN } from '../../configs/constants';
import { filterComparableData } from '../../utils/comparison';
import 'mapbox-gl/dist/mapbox-gl.css';

const MapboxMapData = ({ elData, handleOnStyleChange, keyVal }) => {
  const center = elData.address.value;
  const hasValidCenter = center.lat !== 0 && center.lng !== 0 && center.name;

  const [viewState, setViewState] = useState({
    longitude: center.lng || 0,
    latitude: center.lat || 0,
    zoom: elData.zoom || 12
  });

  // Update view state when address or zoom changes
  useEffect(() => {
    if (hasValidCenter) {
      setViewState({
        longitude: center.lng,
        latitude: center.lat,
        zoom: elData.zoom || 12
      });
    }
  }, [center.lng, center.lat, elData.zoom, hasValidCenter]);

  return (
    <div className="mapData">
      <Resizable
        className="resizable-container"
        minHeight={150}
        maxHeight={400}
        enable={{ top: false, bottom: true }}
        defaultSize={{
          width: '100%',
          height: elData.styles.height,
        }}
        onResizeStop={(params) => handleOnStyleChange(params, keyVal)}
      >
        {hasValidCenter ? (
          <Map
            mapboxAccessToken={MAPBOX_TOKEN}
            {...viewState}
            onMove={evt => setViewState(evt.viewState)}
            style={{ width: '100%', height: '100%' }}
            mapStyle="mapbox://styles/mapbox/streets-v12"
          >
            <Marker
              longitude={center.lng}
              latitude={center.lat}
              color="red"
            />
          </Map>
        ) : (
          <div style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f0f0f0',
            color: '#666'
          }}>
            Select an address to display map
          </div>
        )}
      </Resizable>
    </div>
  );
};

export default memo(MapboxMapData, filterComparableData);